export default "__VITE_ASSET__bFtN9nJk__"